module.exports = __webpack_public_path__ + "static/media/Shield top.f21575bf.svg";